import React, { useEffect, createContext } from "react";
import { Button } from "./Components/Button/Button";
import CimeSeBavimo from "./Components/CimeSeBavimo/CimeSeBavimo";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Partneri from "./Components/Partneri/Partneri";
import ZastoBasStaklo from "./Components/ZastoBasStaklo/ZastoBasStaklo";
import Hero from "./Components/Hero/Hero";
import AOS from "aos";
import "aos/dist/aos.css";
import { AosContext } from "./Components/Context/AosContext";

const App = () => {
  const AOS_DURATION = 700;
  const AOS_DELAY = 400;
  useEffect(() => {
    AOS.init({
      once: true,
      duration: AOS_DURATION,
      easing: "ease-out-back",
      delay: 0,
    });
    AOS.refresh();
  }, []);
  return (
    <AosContext.Provider value={AOS_DELAY}>
      <Navbar active="Pocetna"></Navbar>
      <Hero></Hero>
      <ZastoBasStaklo></ZastoBasStaklo>
      <CimeSeBavimo></CimeSeBavimo>
      <Partneri></Partneri>
      <Footer></Footer>
    </AosContext.Provider>
  );
};

export default App;
